import isEqual from 'lodash/isEqual';

export function isDeepEqual(a: unknown, b: unknown): boolean {
  return isEqual(a, b);
}

export type FilterObjectEntryCallback<V> = (value: V, key: string) => boolean;

export function filterObjectEntries<V = unknown>(
  object: Record<string, V>,
  filterCb: FilterObjectEntryCallback<V> = Boolean,
): Record<string, V> {
  return Object.entries<V>(object).reduce<Record<string, V>>((acc, [key, value]) => {
    if (filterCb(value, key)) {
      acc[key] = value;
    }

    return acc;
  }, {});
}
